import { ScopeOfWorkV2Service } from "@roc/feature-sow-shared/services";

/**
 * The scope of work revision page reads its revision through the secure link session
 * (SecureLinkScopeOfWorkRevisionService); the old public endpoints are gone.
 */
export class ScopeOfWorkRevisionService extends ScopeOfWorkV2Service {
  constructor() {
    super();
    this.url = {};
  }
}
